:host(:not([no-margin])) {
    @include component-spacing;
}

:host {
    display: block;
    color: $color-grey-01-dark;
    background-color: $color-grey-06-bright;
}

.grid {
    @include grid;
}

::slotted(sew-ws-richtext) {
    padding: 32px 0;
}

::slotted(sew-ws-richtext:first-child) {
    grid-column: 2 / 6;
    grid-row: 1;
}

::slotted(sew-ws-richtext:nth-child(2)) {
    grid-column: 6 / 10;
    grid-row: 1;
}

::slotted(sew-picture) {
    grid-column: 10 / 15;
    grid-row: 1;
}

.separator {
    grid-column: 6;
    grid-row: 1;
    height: calc(100% - 64px);
    margin: 32px 0;
    background-color: $color-grey-05-light;
    width: 3px;
    position: relative;
    left: -25.5px; // half column gap + half element width
}

@include mq-4-min {
    ::slotted(sew-picture) {
        grid-column: 10 / 14;
    }
}

@include mq-2 {
    ::slotted(sew-ws-richtext:first-child) {
        grid-column: 2 / 8;
        grid-row: 2;
    }

    ::slotted(sew-ws-richtext:nth-child(2)) {
        grid-column: 8 / 14;
        grid-row: 2;
    }

    ::slotted(sew-picture) {
        grid-column: 1 / -1;
        grid-row: 1;
    }

    .separator {
        grid-column: 8;
        grid-row: 2;
        left: -17.5px; // half column gap + half element width
    }
}

@include mq-1 {
    ::slotted(sew-ws-richtext) {
        padding: 24px 0;
    }

    ::slotted(sew-ws-richtext:first-child) {
        grid-column: 2 / -2;
        grid-row: 2;
    }

    ::slotted(sew-ws-richtext:nth-child(2)) {
        grid-column: 2 / -2;
        grid-row: 4;
        padding-bottom: 40px;
    }

    ::slotted(sew-picture) {
        grid-column: 1 / -1;
        grid-row: 1;
    }

    .separator {
        grid-column: 2 / -2;
        grid-row: 3;
        height: 3px;
        margin: 0;
        width: 100%;
        left: 0;
    }
}
